<template lang="pug">
.container.p-5(v-if="isFullyLoaded", v-cloak)
  .d-flex.justify-content-center
    .col-md-8.col-lg-6
      .alert.alert-success(v-if="isBroadcastSuccessfulySent") Broadcast successfuly sent
      .alert.alert-danger(v-if="errorMessage") {{ errorMessage }}
  .row.justify-content-center
    .col.col-md-8.col-lg-6.bg-white.rounded.shadow-sm.p-4
      h1.text-center.fw-bolder.py-3 Broadcast
      form
        .input-group
          input.form-control(
            type="text",
            placeholder="Paste image URL here",
            v-model="imageUrl",
            :disabled="isDisabled",
            @keypress.enter.prevent=""
          )
        .row.p-2
          .col.position-relative.p-1.image(
            v-for="(url, idx) in images",
            :class="makeGrid(idx)",
            :key="url",
            :id="idx",
          )
            img.w-100.rounded(
              :key="url",
              :src="url",
              :class="{ blink: existedImg === idx }"
            )
            button.trash.btn.btn-light.m-2.position-absolute.bottom-0.end-0(
              type="button",
              @click.prevent="removeImage(url)"
            )
              font-awesome-icon(:icon="['far', 'trash']")
        .mb-4
          textarea.form-control(
            rows="6",
            placeholder="Broadcast text",
            v-model="text"
          )
        .input-group
          button.btn.btn-dark.mx-auto(type="submit", @click.prevent="submit")
            font-awesome-icon.fa-fw.fa-rotate-180.me-2(:icon="['far', 'shuttlecock']")
            | Send broadcast
</template>

<script>
import { sendBroadcast, createCast } from '../services/api/broadcast.api'
import { getBot } from '../services/api/bot.api'
import apiKeyStorage from '../services/storage/apiKey'

export default {
  data() {
    return {
      imageUrl: '',
      text: '',
      existedImg: -1,
      isDisabled: false,
      isFullyLoaded: false,
      isBroadcastSuccessfulySent: false,
      errorMessage: '',
      images: [],
      appVersion: {
        min: 156,
        max: 999
      }
    }
  },
  watch: {
    imageUrl(url) {
      if (this.isValidHttpUrl(url)) {
        this.isDisabled = true
        this.addImage()
        setTimeout(() => {
          this.isDisabled = false
          this.imageUrl = ''
        }, 500)
      }
    }
  },
  created() {
    const botId = this.$route.params.id
    const clientToken = this.$cookie.get('clientToken')
    getBot({ botId, clientToken })
      .then((data) => {
        apiKeyStorage.setKey(data.data.apikey)
        this.isFullyLoaded = true
      })
      .catch((error) => {
        console.error(error)
        this.$router.replace('/')
      })
  },
  methods: {
    async submit() {
      if (
        this.text.length > 0 &&
        confirm('Do you really want to send broadcast?')
      ) {
        try {
          const { id } = await createCast(
            { text: this.text, gallery: this.images },
            apiKeyStorage.getKey()
          )
          await sendBroadcast(
            id,
            { min: this.appVersion.min, max: this.appVersion.max },
            apiKeyStorage.getKey()
          )
          this.isBroadcastSuccessfulySent = true
        } catch (error) {
          this.errorMessage = error
        }
      }
    },
    addImage() {
      const idx = this.images.indexOf(this.imageUrl)
      if (this.imageUrl && idx === -1) {
        this.images.push(this.imageUrl)
      } else {
        this.existedImg = idx
        setTimeout(() => (this.existedImg = -1), 1000)
      }
    },
    removeImage(url) {
      this.images = this.images.filter((imageUrl) => imageUrl !== url)
    },
    makeGrid(idx) {
      const l = this.images.length

      if (idx && l > 2) {
        if (
          l === 5 ||
          l === 3 ||
          ((l - 1) % 3 === 1 && idx < 5) ||
          ((l - 1) % 3 === 2 && idx < 3)
        ) {
          return 'col-6'
        }
        return 'col-4'
      } else {
        return 'col-12'
      }
    },
    isValidHttpUrl(inputTxt) {
      try {
        const url = new URL(inputTxt)
        return url.protocol === 'http:' || url.protocol === 'https:'
      } catch {
        return false
      }
    }
  }
}
</script>

<style lang="sass" scoped>
[v-cloak]
  display: none

button.trash
  opacity: 0
  transition: 0.25s opacity
  &:focus
    opacity: 1

img
  &.blink
    animation: .25s blink 4

.image:hover
  button.btn
    opacity: 1

@keyframes blink
  0%
    opacity: 1
  50%
    opacity: 0.5
  100%
    opacity: 1
</style>
